import { useSearchParams } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageGuide from "components/admin/PageGuide";
import Footer from "examples/Footer";
import PageCard from "components/admin/PageCard";
import SeasonsPanel from "./SeasonsPanel";
import RulesPanel from "./RulesPanel";
import RechargePanel from "./RechargePanel";

// Tab ghi lên URL (?tab=) để F5 hay gửi link vẫn mở đúng chỗ.
const TABS = [
  { key: "seasons", label: "Mùa sự kiện" },
  { key: "rules", label: "Tự lặp lại" },
  { key: "recharge", label: "Sự kiện nạp" },
];

const TAB_SX = { flex: { xs: "0 0 auto", md: "1 1 auto" }, px: 1.5, whiteSpace: "nowrap" };

function EventSeasons() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.key === params.get("tab")) ? params.get("tab") : "seasons";
  const pick = (value) => setParams(value === "seasons" ? {} : { tab: value }, { replace: true });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <PageGuide page="event-seasons" />
        <Tabs
          value={tab}
          onChange={(e, v) => pick(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 1, maxWidth: 560 }}
        >
          {TABS.map((t) => (
            <Tab key={t.key} value={t.key} label={t.label} sx={TAB_SX} />
          ))}
        </Tabs>
        {tab === "seasons" && (
          <PageCard
            title="Mùa sự kiện"
            subtitle="Mỗi mùa là một đợt sự kiện có giờ bắt đầu / kết thúc, mốc quà và bảng xếp hạng. Máy chủ tự bật, tắt và gửi thưởng đúng giờ."
          >
            <SeasonsPanel />
          </PageCard>
        )}
        {tab === "rules" && (
          <PageCard
            title="Tự lặp lại"
            subtitle="Tự tạo mùa mới mỗi ngày / tuần / tháng. Mùa kỳ sau được tạo sẵn trước một kỳ để kịp sửa mốc quà."
          >
            <RulesPanel />
          </PageCard>
        )}
        {tab === "recharge" && <RechargePanel />}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EventSeasons;
